import { gql } from '@apollo/client';
import { OrderInfoShared } from '../fragments';

export default gql`
  query orders(
    $futureFulfillment: Boolean
    $accountId: ID
    $patientId: ID
    $partnerLocationId: [ID!]
    $states: [String!]
    $createdAtStart: String
    $createdAtEnd: String
    $productIds: [ID!]
    $paidByPartner: Boolean
    $courtesyOrder: Boolean
    $registered: Boolean
    $totalMin: Int
    $totalMax: Int
    $toplineRevenueMin: Int
    $toplineRevenueMax: Int
    $earnedRevenueMin: Int
    $earnedRevenueMax: Int
    $partnerRevenueOfficeMin: Int
    $partnerRevenueOfficeMax: Int
    $partnerRevenuePlatformMin: Int
    $partnerRevenuePlatformMax: Int
    $partnerRevenueTotalMin: Int
    $partnerRevenueTotalMax: Int
    $partnerFeeMin: Int
    $partnerFeeMax: Int
    $limit: Int
    $offset: Int
  ) {
    orders(
      futureFulfillment: $futureFulfillment
      accountId: $accountId
      patientId: $patientId
      partnerLocationId: $partnerLocationId
      states: $states
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
      productIds: $productIds
      paidByPartner: $paidByPartner
      courtesyOrder: $courtesyOrder
      registered: $registered
      totalMin: $totalMin
      totalMax: $totalMax
      toplineRevenueMin: $toplineRevenueMin
      toplineRevenueMax: $toplineRevenueMax
      earnedRevenueMin: $earnedRevenueMin
      earnedRevenueMax: $earnedRevenueMax
      partnerRevenueOfficeMin: $partnerRevenueOfficeMin
      partnerRevenueOfficeMax: $partnerRevenueOfficeMax
      partnerRevenuePlatformMin: $partnerRevenuePlatformMin
      partnerRevenuePlatformMax: $partnerRevenuePlatformMax
      partnerRevenueTotalMin: $partnerRevenueTotalMin
      partnerRevenueTotalMax: $partnerRevenueTotalMax
      partnerFeeMin: $partnerFeeMin
      partnerFeeMax: $partnerFeeMax
      limit: $limit
      offset: $offset
    ) {
      ...OrderInfoShared
    }
  }
  ${OrderInfoShared}
`;
